import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { fetchData as fetchDataNode } from "../nodeApi/fetchData";
import { fetchData } from "./UseStudentGetApi";

export const useAdminStudentList = (filters) => {
  return useQuery({
    queryKey: ["get-all-register-students-list", filters],
    queryFn: () => fetchDataNode(`get-all-register-students-list`, filters),
  });
};

export const useAdminApartmentList = (filters) => {
  return useQuery({
    queryKey: ["get-all-apartments-list", filters],
    queryFn: () => fetchDataNode(`get-all-apartments-list`, filters),

  });

};

export const useAdminTrainerList = (filters) => {
  return useQuery({
    queryKey: ["get-all-trainers-list", filters],
    queryFn: () => fetchDataNode(`get-all-trainers-list`, filters),
  });
};

export const useAdminCoOrdinatorList = (filters) => {
  return useQuery({
    queryKey: ["get-all-coordinator-list", filters],
    queryFn: () => fetchDataNode(`get-all-coordinator-list`, filters),
  });
};

export const useTranerUnderCoorList = (id) => {
  return useQuery({
    queryKey: ["coordinator-apartment-count", id],
    queryFn: () => fetchDataNode(`coordinator-apartment-count/${id}`),
  });
};

export const useAdminCountry = () => {
  return useQuery({
    queryKey: ["countries-list"],
    queryFn: () => fetchDataNode(`countries-list`),
  });
};

export const useAllAdminCountry = () => {
  return useQuery({
    queryKey: ["countries-all-list"],
    queryFn: () => fetchDataNode(`countries-all-list`),
  });
};

export const useAdminCity = (filters, options) => {
  return useQuery({
    queryKey: ["cities-list", filters],
    queryFn: () => fetchDataNode("cities-list", filters),

    // If enabled is passed explicitly use it,
    // otherwise use default condition
    enabled:
      options?.enabled ??
      (!!filters?.country_id && !!filters?.state_id),
  });
};


export const useAllAdminCity = (filters) => {
  return useQuery({
    queryKey: ["all-cities-list", filters],
    queryFn: () => fetchDataNode(`all-cities-list`, filters),
    // enabled: !!filters?.country_id && !!filters?.state_id,
  });
};

export const useAdminState = (filters) => {
  return useQuery({
    queryKey: ["states-list", filters],
    queryFn: () => fetchDataNode(`states-list`, filters),
    enabled: !!filters?.country_id,
  })
};


export const useAllAdminState = (filters) => {
  return useQuery({
    queryKey: ["all-states-list", filters],
    queryFn: () => fetchDataNode(`all-states-list`, filters),
    enabled: !!filters?.country_id || !!filters?.status,
  })
};
export const useRegisterStudentCoursesList = (filters) => {
  return useQuery({
    queryKey: ["get-register-student-courses-list", filters],
    queryFn: () => fetchDataNode(`get-register-student-courses-list`, filters),
    enabled: !!filters?.student_id
  })
};

export const useTrainerCoursesList = (filters) => {
  return useQuery({
    queryKey: ["get-trainer-courses-list", filters],
    queryFn: () => fetchDataNode(`get-trainer-courses-list`, filters),
  })
};

export const usePayoutList = (filters = {}) => {
  return useQuery({
    queryKey: ["get-all-payouts-list", filters],
    queryFn: () => fetchDataNode(`get-all-payouts-list`, filters),

  });
};

export const useMarketingList = (filter) => {
  return useQuery({
    queryKey: ["marketing-ads", filter],
    queryFn: () => fetchDataNode(`marketing-ads`, filter),
  });
};



export const useApartmentContantDetail = (filter) => {
  return useQuery({
    queryKey: ["apartment-contact-details", filter],
    queryFn: () => fetchDataNode(`apartment-contact-details`, filter),
  });
};

export const useContinentCodeList = () => {
  return useQuery({
    queryKey: ["countries-code-list"],
    queryFn: () => fetchDataNode(`countries-code-list`),
  });
};

export const useAllUserList = (filter, enabledByParent = false) => {
  const queryOptions = {
    queryKey: ["get-allusers-list", filter],
    queryFn: () => fetchDataNode("get-allusers-list", filter),
  };

  if (enabledByParent) {
    queryOptions.enabled = !!filter?.role;
  }

  return useQuery(queryOptions);
};

export const useRoleList = () => {
  return useQuery({
    queryKey: ["get-roles-list"],
    queryFn: () => fetchDataNode(`get-roles-list`),
  });
};

export const useSchoolList = () => {
  return useQuery({
    queryKey: ["get-allschools-list"],
    queryFn: () => fetchDataNode(`get-allschools-list`),
  });
};

// export const useUnassignCoordinator = () => {
//   return useQuery({
//     queryKey: ["unassigned-coordinator"],
//     queryFn: () => fetchData(`unassigned-coordinator`),
//   });
// };

export const useUnassignApartCord = () => {
  return useQuery({
    queryKey: ["unassigned-coordinator-apartments"],
    queryFn: () => fetchDataNode(`unassigned-coordinator-apartments`),
  });
};

// export const useCoordinatorList = () => {
//   return useQuery({
//     queryKey: ["coordinator-user"],
//     queryFn: () => fetchData(`coordinator-user`),
//   });
// };

export const useStudentCourseNameList = () => {
  return useQuery({
    queryKey: ["student_course_name_list"],
    queryFn: () => fetchDataNode(`student-course-name-list`),
  });
};

export const useStudentCourseByZoneList = () => {
  return useQuery({
    queryKey: ["courses/by-zone"],
    queryFn: () => fetchDataNode(`courses/by-zone`),
  });
};

// export const useAvailableApartmentsForPayout = (filters) => {
//   return useQuery({
//     queryKey: ["available-apartments-for-payout", filters],
//     queryFn: () => fetchData("available-apartments", filters),
//   });
// };

export const useApartmentListForCourse = (filters) => {
  return useQuery({
    queryKey: ["collab-apartment-name-list", filters],
    queryFn: () => fetchDataNode(`collab-apartment-name-list`, filters),
  });
};

// export const useFilterApartmentlist = (id) => {
//   return useQuery({
//     queryKey: ["unassigned-apartments", id],
//     queryFn: () => fetchData(`get-unassigned-apartments/${id}`),
//   });
// };

// export const useTrainerList = () => {
//   return useQuery({
//     queryKey: ["getUnassignedTrainers"],
//     queryFn: () => fetchData(`get-unassigned-trainers`),
//   });
// };


export const useAllSchoolList = () => {
  return useQuery({
    queryKey: ["distinct-schools"],
    queryFn: () => fetchDataNode(`distinct-schools`),
  });
};

// export const useCourseList = () => {
//   return useQuery({
//     queryKey: ["get-all-courses-list"],
//     queryFn: () => fetchData(`get-all-courses-list`),
//   });
// };

export const useCourseApartmentDetail = (filter) => {
  return useQuery({
    queryKey: ["course-apartments", filter],
    queryFn: () => fetchDataNode(`course-apartments`, filter),
    enabled: !!filter,
  });
};
// export const useCourseApartmentDetailByZone = (filter) => {
//   return useQuery({
//     queryKey: ["apartments/by-zone-course", filter],
//     queryFn: () => fetchData(`apartments/by-zone-course`, filter),
//     enabled: !!filter,
//   });
// };


export const useEventApartmentDetail = (filter) => {
  return useQuery({
    queryKey: ["event-based-details", filter],
    queryFn: () => fetchData(`event-based-details`, filter),
    enabled: !!filter,
  });
};

export const useCourseList = () => {
  return useQuery({
    queryKey: ["course-list"],
    queryFn: () => fetchDataNode(`course-list`),
  });
};

export const useEventList = () => {
  return useQuery({
    queryKey: ["event-data"],
    queryFn: () => fetchData(`event-data`),
  });
};

export const useOrderList = (filter) => {
  return useQuery({
    queryKey: ["orders-list", filter],
    queryFn: () => fetchDataNode(`orders-list`, filter),
  });
};



export const useFacilityList = () => {
  return useQuery({
    queryKey: ["facilities"],
    queryFn: () => fetchDataNode(`facilities`),
  });
};


export const useBatchList = () => {
  return useQuery({
    queryKey: ["apartments/get-batches-without-trainer"],
    queryFn: () => fetchDataNode(`apartments/get-batches-without-trainer`),
  });
};

// export const useAdminMoment = (filter) => {
//   return useQuery({
//     queryKey: ["student-memories-list-by-apartment", filter],
//     queryFn: () => fetchData(`student-memories-list-by-apartment`, filter),
//     enabled: !!filter?.course_id && !!filter?.apartment_name,
//   });
// };

export const useAdminAttendaceList = (filter) => {
  return useQuery({
    queryKey: ["attendance-by-filters", filter],
    queryFn: () => fetchDataNode(`attendance-by-filters`, filter),
    enabled: !!filter?.course_id && !!filter?.apartment_id && !!filter?.from_date && !!filter?.to_date,
  });
};

export const useTrainerAttendanceList = (filter) => {
  return useQuery({
    queryKey: ["trainer-attendance", filter],
    queryFn: () => fetchDataNode(`trainer-attendance`, filter),
    enabled: !!filter?.trainer_id,
  });
};

export const useTrainerTimeTable = (filter) => {
  return useQuery({
    queryKey: ["trainer-schedules", filter],
    queryFn: () => fetchDataNode(`trainer-schedules`, filter),
    enabled: !!filter?.trainer_id,
  });
};

export const useGetAllClusters = (filter) => {
  return useQuery({
    queryKey: ["clusters", filter],
    queryFn: () => fetchDataNode(`clusters`, filter),
  });
};

export const useGetAllUserDetailList = () => {
  return useQuery({
    queryKey: ["user-info"],
    queryFn: () => fetchDataNode(`user-info`),
  });
};

export const useClustersUnderCooridinator = (filter) => {
  return useQuery({
    queryKey: ["clusters/by-coordinator", filter],
    queryFn: () => fetchDataNode(`clusters/by-coordinator`, filter),
    enabled: !!filter?.coordinator_id,
  });
};

export const useApartmentByCluster = (filter) => {
  return useQuery({
    queryKey: ["apartments/by-cluster", filter],
    queryFn: () => fetchDataNode(`apartments/by-cluster`, filter),
    enabled: !!filter?.cluster_id,
  });
};

export const useClusterByZone = (filter) => {
  return useQuery({
    queryKey: ["clusters/zone", filter],
    queryFn: () => fetchDataNode(`clusters/zone`, filter),
    enabled: !!filter?.zone_id,
  });
};


export const useUsersUnderZoneHead = (filter) => {
  return useQuery({
    queryKey: ["zone-head-users", filter],
    queryFn: () => fetchDataNode(`zone-head-users`, filter),
    enabled: !!filter?.user_id,
  });
};

export const useApartmentsUnderZoneHead = (filter) => {
  return useQuery({
    queryKey: ["apartments/zone-head", filter],
    queryFn: () => fetchDataNode(`apartments/zone-head`, filter),
    enabled: !!filter?.user_id,
  });
};

// export const useOnlineBatchDetail = (filter) => {
//   return useQuery({
//     queryKey: ["online-batch-details", filter],
//     queryFn: () => fetchData(`online-batch-details`, filter),
//     enabled: !!filter?.event_id,
//   });
// };


export const useGetDiscountCouponCode = (filter) => {
  return useQuery({
    queryKey: ["discounts/get-all-discounts", filter],
    queryFn: () => fetchDataNode(`discounts/get-all-discounts`, filter)
  });
};

export const useGetDiscountCouponCodeByAuth = (filter) => {
  return useQuery({
    queryKey: ["discounts/get-all-discounts-details", filter],
    queryFn: () => fetchDataNode(`discounts/get-all-discounts-details`, filter)
  });
};

export const useAdminDailyReport = (filter) => {
  return useQuery({
    queryKey: ["daily-report", filter],
    queryFn: () => fetchDataNode(`daily-report`, filter)
  });
};

export const useAdminSalesReport = (filter) => {
  return useQuery({
    queryKey: ["enquiry-report", filter],
    queryFn: () => fetchDataNode(`enquiry-report`, filter)
  });
};

export const useAdminFieldReport = (filter) => {
  return useQuery({
    queryKey: ["field-report", filter],
    queryFn: () => fetchDataNode(`field-report`, filter)
  });
};
export const useAdminZoneReport = (filter) => {
  return useQuery({
    queryKey: ["zone-report", filter],
    queryFn: () => fetchDataNode(`zone-report`, filter)
  });
};

export const useAdminOnboardingReport = (filter) => {
  return useQuery({
    queryKey: ["onboarding-report", filter],
    queryFn: () => fetchDataNode(`onboarding-report`, filter)
  });
};


export const useAdminMemoryByApart = (filters) => {
  const isValid = !!filters?.course_id && !!filters?.apartment_id;

  return useInfiniteQuery({
    queryKey: ['student-memories-list-by-apartment', filters],
    queryFn: async ({ pageParam = 1 }) =>
      fetchDataNode('student-memories-list-by-apartment', {
        ...filters,
        page: pageParam,
      }),
    getNextPageParam: (lastPage) => {
      const nextUrl = lastPage?.pagination?.next_page_url;
      if (!nextUrl) return undefined;
      const url = new URL(nextUrl);
      return url.searchParams.get('page');
    },
    enabled: isValid, // ✅ prevents fetching when required filters are missing
  });
};



export const useGetTemplate = (filters) => {
  return useQuery({
    queryKey: ["fetch-templates", filters],
    queryFn: () => fetchDataNode(`fetch-templates`, filters),

  });

};

export const useGetLmsBasicDetail = (id) => {
  return useQuery({
    queryKey: ["lms/basic-details", id],
    queryFn: () => fetchDataNode(`lms/${id}/basic-details`),

  });

};

export const useGetLmsBasicDetailThreejs = (id, options = {}) => {
  return useQuery({
    queryKey: ["lms-basic-detail-threejs", id],
    queryFn: () => fetchDataNode(`lms/three-d/${id}`),
    enabled: options.enabled ?? !!id,
  });
};


export const useGetAddedCourseLmsThreejs = (subtopicId) => {
  return useQuery({
    queryKey: ["lms/course/three-d", subtopicId],
    queryFn: () => fetchData(`lms/course/three-d/${subtopicId}`),
  });
};


export const useGetLmsTopic = (id) => {
  return useInfiniteQuery({
    queryKey: ["lms/topics", id],

    queryFn: ({ pageParam = 1 }) =>
      fetchDataNode(`lms/${id}/topics?page=${pageParam}&limit=10`),

    getNextPageParam: (lastPage) => {
      return lastPage.page < lastPage.totalPages
        ? lastPage.page + 1
        : undefined;
    },
  });
};



export const useGetLmsTopicThreejs = (id) => {
  return useInfiniteQuery({
    queryKey: ["lms/three-d/topics", id],

    queryFn: ({ pageParam = 1 }) =>
      fetchDataNode(`lms/three-d/topics/${id}?page=${pageParam}&limit=10`),

    getNextPageParam: (lastPage) => {
      return lastPage.page < lastPage.totalPages
        ? lastPage.page + 1
        : undefined;
    },
  });
};





export const useGetLmsSubtopic = (id) => {
  return useInfiniteQuery({
    queryKey: ["lms/subtopics", id],

    queryFn: ({ pageParam = 1 }) =>
      fetchDataNode(`lms/${id}/subtopics?page=${pageParam}&limit=10`),

    getNextPageParam: (lastPage) => {
      return lastPage.page < lastPage.totalPages
        ? lastPage.page + 1
        : undefined;
    },
  });
};



export const useGetLmsSubtopicThreejs = (id) => {
  return useInfiniteQuery({
    queryKey: ["lms/subtopics", id],

    queryFn: ({ pageParam = 1 }) =>
      fetchDataNode(`lms/${id}/subtopics?page=${pageParam}&limit=10`),

    getNextPageParam: (lastPage) => {
      return lastPage.page < lastPage.totalPages
        ? lastPage.page + 1
        : undefined;
    },

    enabled: !!id,  
  });
};






export const useGetLmsSubtopicDetail = (id) => {
  return useQuery({
    queryKey: ["lms/subtopicdetail", id],
    queryFn: () => fetchDataNode(`lms/${id}/details`),
    enabled: !!id,

  });

};

// export const useGetLmsSubtopicDetailThreejs = (id) => {
//   return useQuery({
//     queryKey: ["lms/subtopic/details", id],
//     queryFn: () => fetchDataNode(`lms/subtopic/details/${id}`),
//     enabled: !!id,

//   });
// };

export const useGetLmsSubtopicDetailThreejs = (id) => {
  return useQuery({
    queryKey: ["lms/question/answer", id],
    queryFn: () => fetchDataNode(`lms/question/answer/${id}`),
    enabled: !!id,
  });
};





export const useGetLmsMilestoneList = (id) => {
  return useQuery({
    queryKey: ["lms/milestonelist", id],
    queryFn: () => fetchDataNode(`lms/milestones/list/${id}`),
    enabled: !!id,
  });
};

export const useGetLmsSprintList = (id) => {
  return useQuery({
    queryKey: ["lms/sprintlist", id],
    queryFn: () => fetchDataNode(`lms/sprints/list/${id}`),
    enabled: !!id,
  });
};

export const useGetLmsSessionList = (id) => {
  return useQuery({
    queryKey: ["lms/sessionlist", id],
    queryFn: () => fetchDataNode(`lms/sessions/list/${id}`),
    enabled: !!id,
  });
};



export const useGetLmsSubtopicDetailForEditing = (id) => {
  return useQuery({
    queryKey: ["lms/subtopicforediting", id],
    queryFn: () => fetchDataNode(`lms/subtopic/${id}`),
    enabled: !!id,

  });

};


export const useGetLmsSubtopicDetailForEditingThreejs = (id) => {
  return useQuery({
    queryKey: ["lms/course/three-d", id],
    queryFn: () => fetchDataNode(`lms/course/three-d/${id}`),
    enabled: !!id,

  });

};




export const useGetDemoSchooolList = (filter) => {
  return useInfiniteQuery({
    queryKey: ["demo/schoolslist", filter],

    queryFn: ({ pageParam = 1 }) =>
      fetchDataNode(`demo/schools?page=${pageParam}&limit=10`, filter),

    getNextPageParam: (lastPage) => {
      const current = lastPage?.pagination?.current_page;
      const last = lastPage?.pagination?.last_page;

      return current < last ? current + 1 : undefined;
    },
  });
};






export const useGetDemoPublisherlList = (filter) => {
  return useInfiniteQuery({
    queryKey: ["demo/publisherlist", filter],

    queryFn: ({ pageParam = 1 }) =>
      fetchDataNode(`demo/publisher?page=${pageParam}&limit=10`, filter),

    getNextPageParam: (lastPage) => {
      const current = lastPage?.pagination?.current_page;
      const last = lastPage?.pagination?.last_page;

      return current < last ? current + 1 : undefined;
    },
  });
};


export const useGetSubscriberList = (id) => {
  return useInfiniteQuery({
    queryKey: ["subscribers", id],

    queryFn: ({ pageParam = 1 }) =>
      fetchDataNode(`subscribers?page=${pageParam}&limit=10`),

    getNextPageParam: (lastPage) => {
      const currentPage = lastPage?.pagination?.currentPage;
      const totalPages = lastPage?.pagination?.totalPages;

      return currentPage < totalPages
        ? currentPage + 1
        : undefined;
    },
  });
};


















